"use strict";
/*
 * Created on 01 21 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * EntityEventConverter
 *
 * @author Opt
 */


var EntityEventConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(EntityEventConverter, _DataObjectConverter_);

  function EntityEventConverter() {
    _classCallCheck(this, EntityEventConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntityEventConverter).apply(this, arguments));
  }

  return EntityEventConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.EntityEventConverter = EntityEventConverter;